import { INotificationSetting, INotificationSettingValidation, INotificationsSettingFilters } from '../types/notifications';
import { DELIVERY_METHOD } from 'src/constants/deliveryTypes';
import { defaulLangTextValidation, defaultTTranslate, SORTING_DIRECTION } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import { appStore } from '~/mobx/appStore';

export const notificationNavigation = (): IScreenTab[] => [
  { path: SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS(), title: 'txt_order_status' },
  { path: SCREENS.SETTINGS_NOTIFICATIONS_ORDER_SYSTEM(), title: 'ordering_process' },
  { path: SCREENS.SETTINGS_NOTIFICATIONS_WALLET(), title: 'wallet' },
  { path: SCREENS.SETTINGS_NOTIFICATIONS_CURBSIDE(), title: 'curbside', visible: appStore.isAddonsAvailable.curbside },
];

export enum NotificationsSettingColumnName {
  SUBJECT_EN = 'subject',
  SUBJECT_AR = 'subject_ar',
  TEXT_EN = 'message',
  TEXT_AR = 'message_ar',
  DELIVERY_STATUS = 'delivery_method',
  ORDER_STATUS = 'order_status',
}

export enum NotificationsSettingType {
  ORDER = 'o',
  // WAIT_LIST = 'w',
  WALLET = 'l',
}

export enum NotificationsSettingPath {
  ORDER = 'order',
  // WAIT_LIST = 'waitlist',
  WALLET = 'wallet',
}

/**
 * WARNING!!!
 *
 * True only for ORDER and WALLET
 */
export const notificationsSettingLabelPostscript: Record<NotificationsSettingType, string> = {
  [NotificationsSettingType.ORDER]: '_status',
  // [NotificationsSettingType.WAIT_LIST]: '_status',
  [NotificationsSettingType.WALLET]: '_event',
};

export const defaultNotificationSettingFilters: INotificationsSettingFilters = {
  sortField: NotificationsSettingColumnName.SUBJECT_EN,
  sortDir: SORTING_DIRECTION.ASCENDING,
};

export const defaultNotificationSetting: INotificationSetting = {
  id: 0,
  subject: defaultTTranslate,
  message: defaultTTranslate,
  deliveryMethod: DELIVERY_METHOD.APP_NOTIFICATION,
  event: '',
  status: 0,
};

export const defaultNotificationSettingValidation: INotificationSettingValidation = {
  isValid: true,
  subject: defaulLangTextValidation,
  message: defaulLangTextValidation,
};
